import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ProviderService } from '../services/provider.service';
import _ from 'lodash';
import { PatientService } from '../services/patient.service';
import { CustomRouter } from '../routers/custom-router';
import { AppPaths } from '../enums/app-paths.enum';
import { AmplitudeService } from '../services/amplitude.service';
import { AmplitudeEvents } from '../enums/amplitude-events';
import { ToastService } from '../services/toast.service';

export const dataValidationTokenGuard: CanActivateFn = async (route, state) => {
  if (_.isEmpty(route.url)) return true;

  const providerService = inject(ProviderService);
  const patientService = inject(PatientService);
  const customRouter = inject(CustomRouter);
  const amplitudeService = inject(AmplitudeService);
  const toastService = inject(ToastService);

  if (providerService.isToken()) {
    const missingRequiredFields = await patientService.getMissingRequiredFields();
    if (Object.keys(missingRequiredFields).length > 0) {
      // Only show the toast when the patient clicks the Continue button, not when the patient is redirected from another path to the data validation screen.
      if (state?.url?.startsWith(`/${AppPaths.TERMS_AND_CONDITIONS}`)) toastService.openErrorToast('data_validation_guard_missing_fields');
      amplitudeService.showEvent(AmplitudeEvents.PATIENT_REDIRECTED_TO_DATA_VALIDATION, { missingRequiredFields });
      customRouter.navigate([`/${AppPaths.DATA_VALIDATION}`]);
      return false;
    }
  }

  return true;
};
